export default __webpack_public_path__ + "static/media/invite.c62bffe3.svg";